export function formatPhoneNumber(inputField) {
    const phoneNumber = inputField.value.replace(/[^0-9]/g, ''); // clean the input
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber; // no formatting for less than 4 digits
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}

export function formatPhone(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}
